import React, { useState } from "react";
import { editiconorange, rightarrowwhite } from "../../../images";
import TextFieldWithIcon from "../../../components/TextFieldWithIcon/TextFieldWithIcon";
import OtpInput from "react-otp-input";

import FullWidthTextField from "../../../components/TextField/FullWidthTextField";
import Joi from "joi";
import http from "../../../helpers/http";
import { useAuth } from "../../../context/Auth/AuthState";
import config from "../../../config/config";
import { toast } from "react-toastify";
import ToastMsg from "../../../components/ToastMsg/ToastMsg";
import axios from "axios";
import useTheme from "../../../components/useTheme/useTheme";

const EditFirmBusinessEmailId = ({ lightTheme }) => {
  // =============== VARIABLE & STATES  ===========================
  const { theme } = useTheme();
  const [isEditClicked, setIsEditClicked] = useState(false);
  const [formError, setFormError] = useState({});
  const [otpVal, setOtpVal] = useState("");
  const [values, setValues] = useState({
    email: "",
  });
  const [visibility, setVisibility] = useState({
    form: true,
    otp: false,
  });

  const auth = useAuth();

  const joiOptions = config.joiOptions;

  const base_url = config.api_url; //without trailing slash

  // =============== FUNCTIONS  ===========================

  const handleChange = (e) => {
    setValues((prevState) => {
      return {
        ...prevState,
        [e.target.name]: e.target.value,
      };
    });
  };

  const handleotpChange = (otp) => {
    setOtpVal(otp);
  };

  const validate = async (data) => {
    let schemaObj = {
      email: Joi.string()
        .email({ tlds: { allow: false } })
        .required()
        .label("Email"),
    };

    const schema = Joi.object(schemaObj).options({ allowUnknown: true });

    const { error } = schema.validate(data, joiOptions);

    const errors = {};

    if (error) {
      error.details.map((field) => {
        errors[field.path[0]] = field.message;
        return true;
      });
    }

    return errors ? errors : null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let errors = await validate(values);
    setFormError(errors);
    if (Object.keys(errors).length) return;

    try {
      const { data } = await axios.post(
        `${base_url}/business/edit-email/${auth?.user?._id}`,
        { email: values.email },
        { headers: { "Content-Type": "application/json" } }
      );

      if (data.status !== 200) {
        // toast(data.message, config.error_toast_config);
        toast(
          <ToastMsg message={data.message} danger={true} />,
          config.error_toast_config
        );
        return;
      }

      // Success: show OTP input
      setVisibility({ form: false, otp: true });
      toast(
        <ToastMsg message="OTP sent to your new email" />,
        config.success_toast_config
      );
    } catch (err) {
      toast(
        <ToastMsg message={err.response?.data?.message} danger={true} />,
        config.error_toast_config
      );
    }
  };

  const handleOtpSubmit = async (e) => {
    e.preventDefault();

    if (!otpVal) {
      toast(
        <ToastMsg message={"Please enter OTP"} danger={true} />,
        config.error_toast_config
      );
      return;
    }

    try {
      const { data } = await axios.post(
        `${base_url}/business/edit-email-verify/${auth?.user?._id}`,
        { otp: otpVal },
        { headers: { "Content-Type": "application/json" } }
      );

      if (data.status !== 200) {
        toast(
          <ToastMsg message={data.message} danger={true} />,
          config.error_toast_config
        );
        return;
      }

      const { data: updatedUserData } = await axios.get(
        `${base_url}/business/edit-profile/${auth?.user?._id}`
      );

      if (updatedUserData) {
        auth.refresh(updatedUserData?.data);
        setVisibility({ form: false, otp: false });
        setIsEditClicked(false);
        toast(
          <ToastMsg message="Your email is updated" />,
          config.success_toast_config
        );
      }
    } catch (err) {
      console.error(err.response || err);
      toast(
        <ToastMsg message={err.response?.data?.message} danger={true} />,
        config.error_toast_config
      );
    }
  };

  const handleResendOtp = async () => {
    try {
      const { data } = await axios.post(
        `${base_url}/business/edit-email/${auth?.user?._id}`,
        { email: values.email },
        { headers: { "Content-Type": "application/json" } }
      );

      if (data) {
        setOtpVal("");
        toast(<ToastMsg message="OTP resent" />, config.success_toast_config);
      }
    } catch (err) {
      console.error(err.response || err);
      // toast("Something went wrong", config.error_toast_config);
      toast(
        <ToastMsg message={"Something went wrong"} danger={true} />,
        config.error_toast_config
      );
    }
  };

  // =============== HTML RENDERING  ===========================
  // =============== DATA FETCHING  ===========================
  // =============== SIDE EFFECTS  ===========================

  return (
    <>
      <div className="field_wrapper padding_left">
        <TextFieldWithIcon
          label="Edit Firm/Business Email Id*"
          icon={editiconorange}
          onClick={() => {
            setIsEditClicked((prev) => !prev);
            setVisibility({ form: true, otp: false });
            setValues({ email: "" });
            setOtpVal("");
          }}
          value={auth?.user?.email || ""}
          InputProps={{
            readOnly: true,
          }}
          lightTheme={lightTheme}
        />

        {isEditClicked && visibility?.form && (
          <>
            <form onSubmit={handleSubmit}>
              <div className="field_wrapper">
                <FullWidthTextField
                  label="New Firm/Business Email Id*"
                  icon={editiconorange}
                  name="email"
                  value={values.email}
                  onChange={handleChange}
                  lightTheme={lightTheme}
                />
              </div>
              <p className="error">{formError.email}</p>

              <p className={`pass_notice ${theme !== "light" && "text-white"}`}>
                Please enter your new Email ID. <br />
                An OTP verification will be sent to your new email.
              </p>
              <div className="mobile_center">
                <div className="btn_wrapper">
                  <button
                    className={`form_btn ${theme === "dark" && "text-white"}`}
                  >
                    Verify with OTP
                    <img
                      src={rightarrowwhite}
                      alt="icon"
                      className="icon"
                      loading="lazy"
                      style={{
                        filter: theme === "light" ? "invert(1)" : "invert(0)",
                      }}
                    />
                  </button>
                  <button
                    type="button"
                    className={`back_button ${
                      theme === "dark" && "text-white"
                    }`}
                    onClick={() => setIsEditClicked(false)}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </form>
          </>
        )}
        {isEditClicked && visibility?.otp && (
          <>
            <div className="otp_wrapper">
              <div className={`otp_title text-black ${theme === "light" && "text-black"}`}>
                Enter OTP
              </div>
              <div className="otp_box_wrapper">
                <OtpInput
                  value={otpVal}
                  onChange={handleotpChange}
                  numInputs={6}
                  containerStyle="otp_input_wrapper"
                  inputStyle={
                    theme === "dark" ? "otp_input" : "otp_input text-black"
                  }
                  isInputNum={true}
                  focusStyle={
                    theme === "dark" ? "otp_focused" : "otp_focused_light_mode"
                  }
                  shouldAutoFocus
                />
              </div>
              <div className="mobile_center">
                <div className="btn_wrapper">
                  <button
                    className={`form_btn ${theme === "dark" && "text-white"}`}
                    onClick={handleOtpSubmit}
                  >
                    Verify
                    <img
                      src={rightarrowwhite}
                      alt="icon"
                      className="icon"
                      loading="lazy"
                      style={{
                        filter: theme === "light" ? "invert(1)" : "invert(0)",
                      }}
                    />
                  </button>
                  <button
                    className={`back_button ${
                      theme === "dark" && "text-white"
                    }`}
                    onClick={handleResendOtp}
                  >
                    Resend OTP
                  </button>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default EditFirmBusinessEmailId;
